/**
 * When the New look pop-up shows on the web (SCO-3126): local storage only (Phil 2026-10-23). It asks again once a day
 * has passed since it last showed in this browser, while every section is still off (the caller checks newLookAnyOn()).
 * Spec: docs/redesign-2027/native-chrome.md §13.
 */
import { readStoredJson, writeStoredJson } from "../functions/safeStorage";

const KEY = "sh27NewLookPromo";
// Dev only: localStorage newLookPromoForce = true shows it every time.
const FORCE_KEY = "newLookPromoForce";
const AGAIN_MS = 24 * 60 * 60 * 1000;

export function promoDue() {
  if (readStoredJson(FORCE_KEY, false) === true) return true;
  return Date.now() - (Number(readStoredJson(KEY, 0)) || 0) >= AGAIN_MS;
}

export function recordShown() {
  writeStoredJson(KEY, Date.now());
}
